import styled from 'styled-components';

export const StyledButton = styled.button`
  align-items: center;
  appearance: none;
  background: ${props => props.theme.themeColors.zoomButtons.background};
  border-radius: 3px;
  border: 1px solid ${props => props.theme.themeColors.zoomButtons.borderColor};
  box-shadow: ${props => props.theme.themeColors.zoomButtons.boxShadow};
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  height: 48px;
  justify-content: center;
  transition: all 0.15s ease;
  width: 48px;

  &:hover {
    background: ${props =>
      props.theme.themeColors.zoomButtons.backgroundOnHover};
    border: 1px solid
      ${props => props.theme.themeColors.zoomButtons.borderColorOnHover};
    box-shadow: ${props =>
      props.theme.themeColors.zoomButtons.boxShadowOnHover};

    & line {
      stroke: ${props => props.theme.themeColors.zoomButtons.iconColorOnHover};
    }
    & path {
      stroke: ${props => props.theme.themeColors.zoomButtons.iconColorOnHover};
    }
  }

  &:active {
    background: ${props =>
      props.theme.themeColors.zoomButtons.backgroundOnActive};
    border: 1px solid
      ${props => props.theme.themeColors.zoomButtons.borderColorOnActive};

    & line {
      stroke: ${props => props.theme.themeColors.zoomButtons.iconColorOnActive};
    }
    & path {
      stroke: ${props => props.theme.themeColors.zoomButtons.iconColorOnActive};
    }
  }
`;
